import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Usuario } from '../models/usuario.model';
import { environment } from 'src/environments/environment';
import { Observable, map } from 'rxjs';
import { LoginRequest } from '../models/request/login-request.model';
import { AlterarSenhaRequest } from '../models/request/alterar-senha.request.model';
import { UsuarioNovaSenha } from '../models/usuario-nova-senha.model';
import { AuthenticationService } from './authentication.service';
import { EmpresaResponse } from '../models/response/empresa-response.model';
import { UsuarioResponse } from '../models/response/usuario-response.model';
import { DashboardLocalizacaoResponse } from '../models/response/dashboard-localizacao.model';
import { DashboardMovimentoResponse } from '../models/response/dashboard-movimento.model';
import { DashboardCardResponse } from '../models/response/dashboard-cards.model';
import { LoginResponse } from '../models/response/login-response.model';
import { MeusPedidosRequest } from '../models/request/meus-pedidos-request.model';
import { MeusPedidosResponse } from '../models/response/meus-pedidos-response.model';
import { LocalizacoesResponse } from '../models/response/localizacoes-response.model';
import { LojaResponse } from '../models/response/loja-response.model';
import { ClienteResponse } from '../models/response/cliente-response.model';
import { ProdutoResponse } from '../models/response/produto-response.model';
import { NovoPedidoRequest } from '../models/request/novo-pedido.request.model';
import { Cliente } from '../models/cliente.model';
import { Loja } from '../models/loja.model';

@Injectable({
  providedIn: 'root'
})
export class WeblabService {
  public clientes: Array<Cliente>;
  public lojas: Array<Loja>;

  constructor(private httpClient: HttpClient,
    private authenticationService: AuthenticationService) { }

  getEmpresa(tokenAcesso: string): Observable<EmpresaResponse> {
    let headers = new HttpHeaders();
    headers = headers.set('custom-header-token-de-acesso', tokenAcesso);

    return this.httpClient.get<EmpresaResponse>(`${environment.api_url}/oticomlab-empresa`, { headers });
  }

  getUsuario(): Observable<UsuarioResponse> {
    return this.httpClient.get<UsuarioResponse>(`${environment.api_url}/oticomlab-usuario`);
  }

  login(usuario: Usuario, tokenAcesso: string): Observable<LoginResponse> {
    let request: LoginRequest = {
      "chave": environment.chave_weblab, //"923pPk59",
      "token_de_acesso": tokenAcesso, //"3Sh62mkc11",
      "e_mail": usuario.email, //"michelle.yukari@gmail.com",
      "senha":usuario.senha, //"SenhaTestes"
    }

    return this.httpClient.post<LoginResponse>(`${environment.api_url}/login`, request);
  }

  alterarSenha(usuario: UsuarioNovaSenha): Observable<any> {
    let request: AlterarSenhaRequest = {
      "chave": environment.chave_weblab, //"923pPk59",
      "token_de_acesso": this.authenticationService.obterEmpresa?.token_acesso, //"3Sh62mkc11",
      "e_mail": usuario.email,
      "senha":usuario.senhaNova
    }

    return this.httpClient.post(`${environment.api_url}/alterar-senha`, request, { responseType: 'text' });
  }

  esqueciSenha(email: string): Observable<any> {
    let request: any = {
      "chave": environment.chave_weblab, //"923pPk59",
      "token_de_acesso": this.authenticationService.obterEmpresa?.token_acesso, //"3Sh62mkc11",
      "e_mail": email,
      // "senha": usuario.senhaNova
    }

    return this.httpClient.post(`${environment.api_url}/gerar-senha`, request, { responseType: 'text' });
  }

  dashboardCards(): Observable<DashboardCardResponse> {
    return this.httpClient.get<DashboardCardResponse>(`${environment.api_url}/dashboard-cards`);
  }

  dashboardLocalizacoes(): Observable<DashboardLocalizacaoResponse> {
    return this.httpClient.get<DashboardLocalizacaoResponse>(`${environment.api_url}/dashboard-localizacoes`);
  }

  dashboardMovimentacoes(periodo_inicial: string, periodo_final: string): Observable<DashboardMovimentoResponse> {
    return this.httpClient.get<DashboardMovimentoResponse>(`${environment.api_url}/dashboard-movimento?periodo_inicial=${periodo_inicial}&periodo_final=${periodo_final}`);
  }

  meusPedidos(request: MeusPedidosRequest): Observable<MeusPedidosResponse> {
    let queryParams = new HttpParams();

    queryParams = queryParams.append("filtro_data", request.filtro_data);
    queryParams = queryParams.append("limit", request.limit);
    queryParams = queryParams.append("offset", request.offset);

    if (request.valor_filtro_data_inicial)
      queryParams = queryParams.append("valor_filtro_data_inicial", request.valor_filtro_data_inicial);

    if (request.valor_filtro_data_final)
      queryParams = queryParams.append("valor_filtro_data_final", request.valor_filtro_data_final);

    if (request.filtro && request.valor_filtro) {
      queryParams = queryParams.append("filtro", request.filtro);
      queryParams = queryParams.append("valor_filtro", request.valor_filtro);
    }

    if (request.localizacao)
      queryParams = queryParams.append("localizacao", request.localizacao);

    if (request.status)
      queryParams = queryParams.append("status", request.status);

    return this.httpClient.get<MeusPedidosResponse>(`${environment.api_url}/meus-pedidos`, { params: queryParams });
  }

  localizacoes(): Observable<LocalizacoesResponse> {
    return this.httpClient.get<LocalizacoesResponse>(`${environment.api_url}/localizacoes`);
  }

  buscarLojas(): Observable<LojaResponse> {
    return this.httpClient.get<LojaResponse>(`${environment.api_url}/lojas`);
  }

  buscarClientes(): Observable<ClienteResponse> {
    return this.httpClient.get<ClienteResponse>(`${environment.api_url}/clientes?data_criacao_alteracao=null`);
  }

  produtos(cod_loja: number | undefined, cod_cliente: number | undefined): Observable<ProdutoResponse> {
    return this.httpClient.get<ProdutoResponse>(
      `${environment.api_url}/produtos?data_criacao_alteracao=null&somente_ativos=true&loja_cod=${cod_loja}&cliente_cod=${cod_cliente}`);
  }

  produtosBusca(cod_loja: number, cod_cliente: number, descricao: string = '', limit: number = 20, offset: number = 0): Observable<ProdutoResponse> {
    const params: any = {
      data_criacao_alteracao: 'null',
      somente_ativos: true,
      loja_cod: cod_loja,
      cliente_cod: cod_cliente,
      limit,
      offset
    };
    if (descricao) params.descricao = descricao;
    return this.httpClient.get<ProdutoResponse>(`${environment.api_url}/produtos`, { params });
  }

  produtosId(cod_produto: number): Observable<ProdutoResponse> {
    return this.httpClient.get<ProdutoResponse>(
      `${environment.api_url}/produtos?data_criacao_alteracao=null&codigo=${cod_produto}`);
  }
  cadastrarPedido(pedido: NovoPedidoRequest): Observable<any> {
    return this.httpClient.post(`${environment.api_url}/ordem-de-servico`, pedido);
  }

  listarPedido(idpedido: any): Observable<any> {
    return this.httpClient.get<any>(`${environment.api_url}/ordem-de-servico?mov_tipo_nro=${idpedido}`);
  }

  buscarClienteCod(cod_clientes: any) {
    return this.httpClient.get<any>(`${environment.api_url}/clientes?cod_clientes=${cod_clientes}`);

  }
  
}
